/** LiveTiles brand colour for the admin portal. The side nav uses it too, in assets/styles/branding.css. */
export const brandColor = '#00b0be';
